import frontendApi from "./frontend";
import userApi from "./user";
import authApi from "./auth";
import statsApi from "./stats";
import dataApi from "./data";

export const { FILES_API_URL } = process.env;

export { frontendApi, userApi, authApi, statsApi, dataApi };
/** ссылка для файлов */
export function fileUrl(fileId, type = "download") {
  if (fileId) {
    return `${FILES_API_URL}/file_${fileId}/${type}`;
  }
}

// быстрое присваивание результат в указанный сеттер данных
export const setSuccess = (setData) => ({
  onSuccess(body) {
    setData(body);
  },
});
